module.exports = __webpack_public_path__ + "img/twitter-icon.7b342001.svg";